/* Peach Perfect Rezepte: Portionsrechner, Rezeptübersicht (Suche/Filter) und Wochenplaner */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];

  /* Texte in der Shopsprache (snippets/recipe-i18n.liquid), Deutsch als Rückfall */
  const T = Object.assign({
    lang: 'de', serving: 'Portion', servings: 'Portionen', countOne: '1 Rezept', countOther: '[count] Rezepte',
    min: 'Min.', gProtein: 'g Protein',
    days: ['Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag', 'Sonntag'],
    slots: ['Frühstück', 'Mittag', 'Abend', 'Snack'],
    emptyDay: 'noch leer', change: 'Ändern', remove: 'Entfernen', slotOnDay: '[slot] am [day]',
    changeLabel: '[slot] am [day] ändern', removeLabel: '[slot] am [day] entfernen', add: '+ Rezept wählen',
    noMatch: 'Keine passenden Rezepte gefunden.', planTitle: '«[title]» einplanen', chooseSlot: 'Wähle Tag und Mahlzeit:',
    listEmpty: 'Plane zuerst ein paar Rezepte ein – die Einkaufsliste entsteht automatisch.', also: 'Ausserdem',
    hint: 'Mengen für [count] [persons] pro Mahlzeit, aufgerundet auf Viertel.', person: 'Person', people: 'Personen', leftovers: 'Reste von gestern',
    diets: { vegetarisch: 'Vegetarisch', vegan: 'Vegan', pescetarisch: 'Pescetarisch', glutenfrei: 'Glutenfrei', laktosefrei: 'Laktosefrei', 'low carb': 'Low Carb' },
    dietAll: 'Alles', dietMismatch: 'Passt nicht zu «[diet]»', noDietMatch: 'Für diese Mahlzeit gibt es noch kein Rezept mit «[diet]».',
    showAll: 'Alle Rezepte zeigen', gaps: 'Es gibt noch nicht genug Rezepte für jede Mahlzeit.',
    dietGaps: 'Mit «[diet]» gibt es noch nicht genug Rezepte für jede Mahlzeit.', gapsCount: 'Ohne Rezept: [count] von [total] Mahlzeiten – du kannst sie selbst füllen.',
    dietChanged: 'Geplante Mahlzeiten, die nicht zu «[diet]» passen: [count].', suggest: 'Woche vorschlagen',
    weekSum: '[count] von [total] Mahlzeiten geplant', avgDay: 'Ø pro Tag: [kcal] kcal · [protein] g Protein', dayStatus: '[day]: [count] von [total] geplant'
  }, window.fcRecipesT || {});
  const fill = (s, v) => s.replace(/\[(\w+)\]/g, (m, k) => (k in v ? v[k] : m));
  const esc = (s) => String(s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const DEZ = T.lang === 'en' ? '.' : ',';

  /* ---------- Mengen lesen und umrechnen ---------- */
  const BRUCH = { '½': 0.5, '¼': 0.25, '¾': 0.75, '⅓': 1 / 3, '⅔': 2 / 3 };
  const ZAHL = '(\\d+(?:[.,]\\d+)?|[½¼¾⅓⅔])';
  const RE_MENGE = new RegExp('^' + ZAHL + '(?:\\s*[–-]\\s*' + ZAHL + ')?(\\s*)');
  const toNum = (t) => (t in BRUCH ? BRUCH[t] : parseFloat(String(t).replace(',', '.')));
  const fmt = (n) => {
    if (n >= 10) return String(Math.round(n));
    const r = Math.round(n * 4) / 4;
    const ganz = Math.floor(r);
    const rest = r - ganz;
    const z = rest === 0.5 ? '½' : rest === 0.25 ? '¼' : rest === 0.75 ? '¾' : '';
    if (!z) return String(Math.round(n * 10) / 10).replace('.', DEZ);
    return ganz ? ganz + z : z;
  };
  const skaliere = (text, faktor) => {
    const m = text.match(RE_MENGE);
    if (!m || faktor === 1) return text;
    const a = toNum(m[1]) * faktor;
    const b = m[2] ? toNum(m[2]) * faktor : null;
    return fmt(a) + (b !== null ? '–' + fmt(b) : '') + m[3] + text.slice(m[0].length);
  };

  /* ---------- Drucken ---------- */
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-fc-print]')) { e.preventDefault(); window.print(); }
  });

  /* ---------- Rezeptseite: Portionen ---------- */
  const rezept = $('[data-fc-recipe]');
  if (rezept) {
    const basis = parseInt(rezept.dataset.portionen, 10) || 2;
    let aktuell = basis;
    const out = $('[data-fc-portions-value]', rezept);
    const items = $$('[data-fc-q]', rezept).map((el) => ({ el, text: el.textContent.trim() }));
    const label = out ? out.nextElementSibling : null;
    const render = () => {
      if (out) out.textContent = aktuell;
      if (label) label.textContent = aktuell === 1 ? T.serving : T.servings;
      items.forEach((i) => { i.el.textContent = skaliere(i.text, aktuell / basis); });
    };
    $('[data-fc-portions-minus]', rezept)?.addEventListener('click', () => { if (aktuell > 1) { aktuell -= 1; render(); } });
    $('[data-fc-portions-plus]', rezept)?.addEventListener('click', () => { if (aktuell < 12) { aktuell += 1; render(); } });
  }

  /* ---------- Rezeptübersicht: Suche und Filter ----------
     Oben die Art als Reiter (eine zur Zeit), im Button «Filter» weitere Filter (mehrere), dazu Suche (Wilhelm 30.10.2026) */
  const uebersicht = $('[data-fc-recipes]');
  if (uebersicht) {
    const karten = $$('[data-fc-rcp]', uebersicht);
    const suche = $('[data-fc-recipes-search]', uebersicht);
    const reiter = $$('[data-fc-recipes-art]', uebersicht);
    const chips = $$('[data-fc-recipes-filter]', uebersicht);
    const schnell = $('[data-fc-recipes-quick]', uebersicht);
    const zaehler = $('[data-fc-recipes-count]', uebersicht);
    const leer = $('[data-fc-recipes-empty]', uebersicht);
    const nAnzeige = $('[data-fc-recipes-n]', uebersicht);
    const mehr = $('[data-fc-recipes-more]', uebersicht);
    const aktiv = new Set();
    let art = '';
    let nurSchnell = false;
    const setPressed = (b, on) => { b.classList.toggle('is-active', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); };
    const anwenden = () => {
      const q = (suche?.value || '').trim().toLowerCase();
      let n = 0;
      karten.forEach((k) => {
        const tags = (k.dataset.tags || '').split('|');
        const ok = (!art || tags.includes(art))
          && [...aktiv].every((t) => tags.includes(t))
          && (!nurSchnell || (parseInt(k.dataset.zeit, 10) || 999) <= 15)
          && (!q || (k.dataset.text || '').includes(q) || tags.some((t) => t.includes(q)));
        k.hidden = !ok;
        if (ok) n += 1;
      });
      reiter.forEach((r) => setPressed(r, r.dataset.fcRecipesArt === art));
      const zusatz = aktiv.size + (nurSchnell ? 1 : 0);
      if (nAnzeige) { nAnzeige.textContent = zusatz; nAnzeige.hidden = zusatz === 0; }
      if (zaehler) zaehler.textContent = n === 1 ? T.countOne : fill(T.countOther, { count: n });
      if (leer) leer.hidden = n > 0;
    };
    reiter.forEach((r) => r.addEventListener('click', () => { art = r.dataset.fcRecipesArt; anwenden(); }));
    chips.forEach((c) => c.addEventListener('click', () => {
      const t = c.dataset.fcRecipesFilter;
      if (aktiv.has(t)) aktiv.delete(t); else aktiv.add(t);
      setPressed(c, aktiv.has(t));
      anwenden();
    }));
    schnell?.addEventListener('click', () => { nurSchnell = !nurSchnell; setPressed(schnell, nurSchnell); anwenden(); });
    $('[data-fc-recipes-reset]', uebersicht)?.addEventListener('click', () => {
      aktiv.clear(); nurSchnell = false; chips.forEach((c) => setPressed(c, false)); if (schnell) setPressed(schnell, false); anwenden();
    });
    /* Filterfeld schliessen, wenn daneben geklickt wird */
    document.addEventListener('click', (e) => { if (mehr && mehr.open && !mehr.contains(e.target)) mehr.open = false; });
    suche?.addEventListener('input', anwenden);
    /* ?filter=… aus Links (Startseite, Rezeptseite): Art als Reiter, sonst als weiterer Filter */
    const start = (new URLSearchParams(location.search).get('filter') || '').toLowerCase();
    if (start) {
      if (reiter.some((r) => r.dataset.fcRecipesArt === start)) art = start;
      else {
        const c = chips.find((x) => x.dataset.fcRecipesFilter === start);
        if (c) { aktiv.add(start); setPressed(c, true); }
      }
    }
    anwenden();
  }

  /* ---------- Wochenplaner ----------
     Plant wie von Hand (Wilhelm 30.10.2026: «er würfelt nur, er sollte sinnvoll entscheiden»):
     – abends kochen; Gerichte zum Vorkochen (Meal Prep) doppelt, am nächsten Mittag gibt es den Rest
     – unter der Woche mittags schnelle Rezepte, aufwendigere am Abend und am Wochenende
     – Frühstück zum Vorbereiten für 2 Werktage, am Wochenende gern das aufwendigere Frühstück
     – Snacks auf Vorrat für mehrere Tage, so lange die Portionen für alle Personen reichen
     – das Ziel gewichtet die Auswahl: Abnehmen weniger Kalorien, Muskelaufbau mehr Protein
     Ein Eintrag ist entweder ein Rezept (Handle) oder ein Verweis { von: 'mo-ab' } auf die Mahlzeit, aus der er stammt. */
  const planer = $('[data-fc-planner]');
  if (!planer) return;
  let rezepte = [];
  try { rezepte = JSON.parse($('[data-fc-planner-data]', planer).textContent); } catch (e) { rezepte = []; }
  const nachHandle = Object.fromEntries(rezepte.map((r) => [r.handle, r]));
  /* Kürzel und Tags bleiben deutsch (gespeicherte Pläne, Rezept-Tags), nur die Anzeige folgt der Sprache */
  const TAGE = ['mo', 'di', 'mi', 'do', 'fr', 'sa', 'so'].map((k, i) => [k, T.days[i]]);
  const SLOTS = [['fr', 'frühstück'], ['mi', 'hauptgericht'], ['ab', 'hauptgericht'], ['sn', 'snacks & desserts']].map(([k, tag], i) => [k, T.slots[i], tag]);
  const ARTEN = ['frühstück', 'hauptgericht', 'snacks & desserts', 'dips & beilagen'];
  const ALLE = TAGE.length * SLOTS.length;
  const KEY = 'fc-wochenplan-v1';
  const leererPlan = () => ({ ziel: '', diaet: '', personen: 1, reste: true, plan: {} });
  let state = leererPlan();
  try { state = Object.assign(leererPlan(), JSON.parse(localStorage.getItem(KEY) || '{}')); } catch (e) { /* kein Speicher */ }
  const speichern = () => { try { localStorage.setItem(KEY, JSON.stringify(state)); } catch (e) { /* kein Speicher */ } };
  const hatTag = (r, t) => !!r && (r.tags || []).some((x) => x.toLowerCase() === t);
  const zahl = (n) => Math.round(n).toLocaleString(T.lang + '-CH');
  const kurz = (tk) => { const t = TAGE.find((x) => x[0] === tk); return t ? t[1].slice(0, 2) : tk; };
  const artVon = (r) => ARTEN.find((a) => hatTag(r, a)) || 'hauptgericht';
  // Texte aus Liquid kommen teils mit &amp; an; für die Anzeige zurückwandeln (esc() maskiert danach wieder)
  const roh = (t) => { const x = document.createElement('textarea'); x.innerHTML = String(t || ''); return x.value; };
  const artName = (a) => roh((T.arts && T.arts[a]) || a);

  /* Ernährungsformen: angeboten wird nur, was bei mindestens einem Rezept als Tag steht.
     Ein Filter lässt auch strengere Formen zu (vegane Rezepte sind auch vegetarisch). */
  const DIAETEN = [
    ['vegetarisch', ['vegetarisch', 'vegan']],
    ['vegan', ['vegan']],
    ['pescetarisch', ['pescetarisch', 'vegetarisch', 'vegan']],
    ['glutenfrei', ['glutenfrei']],
    ['laktosefrei', ['laktosefrei']],
    ['low carb', ['low carb', 'lowcarb', 'low-carb']]
  ];
  const diaetName = (k) => (T.diets && T.diets[k]) || k.charAt(0).toUpperCase() + k.slice(1);
  const passtZu = (r, k) => { const d = DIAETEN.find((x) => x[0] === k); return !d || d[1].some((t) => hatTag(r, t)); };
  const passtDiaet = (r) => !state.diaet || passtZu(r, state.diaet);
  const angeboten = DIAETEN.filter(([k, alias]) => rezepte.some((r) => hatTag(r, k) || (k === 'low carb' && alias.some((t) => hatTag(r, t)))));
  if (state.diaet && !angeboten.some(([k]) => k === state.diaet)) state.diaet = '';

  /* Einträge lesen: Verweise zeigen auf ihre Herkunft */
  const eintrag = (key) => {
    const v = state.plan[key];
    if (!v) return null;
    if (typeof v === 'string') return nachHandle[v] ? { r: nachHandle[v], von: null } : null;
    const q = state.plan[v.von];
    return typeof q === 'string' && nachHandle[q] ? { r: nachHandle[q], von: v.von } : null;
  };
  const abhaengige = (key) => Object.keys(state.plan).filter((k) => state.plan[k] && state.plan[k].von === key);
  const vorratFaehig = (r, sk) => {
    if (!r) return false;
    if (sk === 'mi' || sk === 'ab') return hatTag(r, 'meal prep');
    if (sk === 'fr') return hatTag(r, 'meal prep');
    return (r.portionen || 1) >= 4;
  };
  const setze = (key, handle) => {
    state.plan[key] = handle;
    const sk = key.split('-')[1];
    if (!vorratFaehig(nachHandle[handle], sk)) abhaengige(key).forEach((k) => delete state.plan[k]);
  };
  const entferne = (key) => { abhaengige(key).forEach((k) => delete state.plan[k]); delete state.plan[key]; };

  const ICON_TAUSCH = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 9h13l-4-4"/><path d="M20 15H7l4 4"/></svg>';
  const ICON_WEG = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';
  const ICON_UHR = '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg>';

  /* Woche: am Computer ein Raster (Tage als Spalten, Mahlzeiten als Zeilen), am Handy ein Tag nach dem anderen über Reiter */
  const week = $('[data-fc-planner-week]', planer);
  const tabs = $('[data-fc-planner-tabs]', planer);
  const summeEl = $('[data-fc-planner-sum]', planer);
  const hinweis = $('[data-fc-planner-note]', planer);
  let aktiv = TAGE[(new Date().getDay() + 6) % 7][0];
  const tagWerte = (tk) => {
    let kcal = 0; let prot = 0; let n = 0;
    SLOTS.forEach(([sk]) => { const e = eintrag(tk + '-' + sk); if (e) { kcal += e.r.kcal; prot += e.r.protein; n += 1; } });
    return { kcal, prot, n };
  };
  const zeigeAktiv = () => {
    $$('[data-day]', week).forEach((el) => el.classList.toggle('is-off', el.dataset.day !== aktiv));
    $$('button', tabs).forEach((b) => b.setAttribute('aria-pressed', b.dataset.tk === aktiv ? 'true' : 'false'));
  };
  const renderWoche = () => {
    const teile = ['<div class="fc-pgrid__corner" aria-hidden="true"></div>'];
    let geplant = 0; let tageVoll = 0; let kcalSum = 0; let protSum = 0; let kochen = 0;
    TAGE.forEach(([tk, tn]) => {
      const w = tagWerte(tk);
      geplant += w.n;
      /* Durchschnitt nur über vollständig geplante Tage, sonst wirkt er zu tief */
      if (w.n === SLOTS.length) { tageVoll += 1; kcalSum += w.kcal; protSum += w.prot; }
      teile.push(`<div class="fc-pgrid__day" data-day="${tk}"><b>${tn}</b>${w.n ? `<small>${zahl(w.kcal)} kcal</small><small>${zahl(w.prot)} ${T.gProtein}</small>` : `<small>${T.emptyDay}</small>`}</div>`);
    });
    SLOTS.forEach(([sk, sn]) => {
      teile.push(`<div class="fc-pgrid__slot">${sn}</div>`);
      TAGE.forEach(([tk, tn]) => {
        const key = tk + '-' + sk;
        const e = eintrag(key);
        const lbl = `<span class="fc-pcell__lbl">${sn}</span>`;
        if (!e) {
          teile.push(`<div class="fc-pcell" data-day="${tk}"><button type="button" class="fc-pcell__add" data-waehle="${key}" aria-label="${esc(fill(T.slotOnDay, { slot: sn, day: tn }))}: ${esc(T.add)}">${lbl}<span class="fc-pcell__plus" aria-hidden="true">+</span><span class="fc-pcell__addtxt">${esc(T.add.replace(/^\+\s*/, ''))}</span></button></div>`);
          return;
        }
        const r = e.r;
        const haupt = sk === 'mi' || sk === 'ab';
        let marke = '';
        if (e.von) marke = `<em class="fc-pcell__mark is-rest">${esc(fill(haupt ? T.restFrom : T.batchFrom, { day: kurz(e.von.split('-')[0]) }))}</em>`;
        else {
          const n = abhaengige(key).length;
          if (haupt) kochen += 1;
          if (n) marke = `<em class="fc-pcell__mark is-cook">${esc(fill(haupt ? T.cookFor : T.batchFor, { n: n + 1 }))}</em>`;
        }
        const warn = state.diaet && !passtDiaet(r);
        teile.push(`<div class="fc-pcell is-full${e.von ? ' is-von' : ''}${warn ? ' is-warn' : ''}" data-day="${tk}">
          <a class="fc-pcell__card" href="${r.url}" title="${esc(r.title)}">
            <span class="fc-pcell__img">${r.img ? `<img src="${r.img}" alt="" loading="lazy" width="400" height="300">` : ''}</span>
            <span class="fc-pcell__txt">${lbl}${marke}<b>${esc(r.title)}</b><small><span>${r.zeit ? ICON_UHR + ' ' + r.zeit + ' ' + T.min : ''}</span><span>${r.protein} ${T.gProtein}</span></small>${warn ? `<em class="fc-pcell__warn">${esc(fill(T.dietMismatch, { diet: diaetName(state.diaet) }))}</em>` : ''}</span>
          </a>
          <div class="fc-pcell__acts">
            <button type="button" data-tausch="${key}" title="${esc(T.change)}" aria-label="${esc(fill(T.changeLabel, { slot: sn, day: tn }))}">${ICON_TAUSCH}</button>
            <button type="button" data-weg="${key}" title="${esc(T.remove)}" aria-label="${esc(fill(T.removeLabel, { slot: sn, day: tn }))}">${ICON_WEG}</button>
          </div>
        </div>`);
      });
    });
    week.innerHTML = teile.join('');
    $$('[data-waehle], [data-tausch]', week).forEach((b) => b.addEventListener('click', () => waehle(b.dataset.waehle || b.dataset.tausch)));
    $$('[data-weg]', week).forEach((b) => b.addEventListener('click', () => { entferne(b.dataset.weg); speichern(); renderWoche(); renderListe(); }));

    tabs.innerHTML = TAGE.map(([tk, tn]) => {
      const w = tagWerte(tk);
      const punkte = SLOTS.map(([sk]) => `<i${eintrag(tk + '-' + sk) ? ' class="is-on"' : ''}></i>`).join('');
      return `<button type="button" data-tk="${tk}" aria-label="${esc(fill(T.dayStatus, { day: tn, count: w.n, total: SLOTS.length }))}"><b>${tn.slice(0, 2)}</b><span>${punkte}</span></button>`;
    }).join('');
    $$('button', tabs).forEach((b) => b.addEventListener('click', () => { aktiv = b.dataset.tk; zeigeAktiv(); }));
    zeigeAktiv();

    summeEl.innerHTML = `<b>${fill(T.weekSum, { count: geplant, total: ALLE })}</b>${kochen ? `<span>${fill(T.cookCount, { count: kochen })}</span>` : ''}${tageVoll ? `<span>${fill(T.avgDay, { kcal: zahl(kcalSum / tageVoll), protein: zahl(protSum / tageVoll) })}</span>` : ''}`;
  };
  const zeigeHinweis = (text, neuVorschlagen) => {
    hinweis.innerHTML = text ? esc(text) + (neuVorschlagen ? ` <button type="button" class="fc-planner__notebtn">${esc(T.suggest)}</button>` : '') : '';
    hinweis.hidden = !text;
    const b = $('button', hinweis);
    if (b) b.addEventListener('click', () => vorschlagen());
  };

  /* ---------- Rezeptauswahl: grosses Fenster mit Reitern (Art), Filtern und Suche ---------- */
  const dlg = $('[data-fc-planner-dialog]', planer);
  const dlgListe = $('[data-fc-planner-dlg-list]', planer);
  const dlgSuche = $('[data-fc-planner-dlg-search]', planer);
  const dlgTitel = $('[data-fc-planner-dlg-title]', planer);
  const dlgSlot = $('[data-fc-planner-dlg-slot]', planer);
  const dlgArten = $('[data-fc-pdlg-arts]', planer);
  const dlgChips = $('[data-fc-pdlg-chips]', planer);
  const dlgCount = $('[data-fc-pdlg-count]', planer);
  const dlgFilter = $('[data-fc-pdlg-filter]', planer);
  $('[data-fc-pdlg-close]', planer).addEventListener('click', () => dlg.close());
  dlg.addEventListener('click', (e) => { if (e.target === dlg) dlg.close(); });
  dlg.addEventListener('close', () => document.documentElement.classList.remove('fc-pdlg-offen'));
  const oeffneDlg = () => { document.documentElement.classList.add('fc-pdlg-offen'); dlg.showModal(); };
  const FILTER = [
    ['schnell', T.quick, (r) => (r.zeit || 99) <= 20],
    ['protein', T.highProtein, (r) => (r.protein || 0) >= 25],
    ['leicht', T.light, (r) => (r.kcal || 9999) <= 400]
  ];
  let wahl = { art: '', diaet: '', extra: new Set(), onPick: null };
  const artenMitRezept = ARTEN.filter((a) => rezepte.some((r) => hatTag(r, a)));
  const zeigeListe = () => {
    const q = (dlgSuche.value || '').trim().toLowerCase();
    const treffer = rezepte.filter((r) => (!wahl.art || hatTag(r, wahl.art))
      && (!wahl.diaet || passtZu(r, wahl.diaet))
      && FILTER.every(([k, , f]) => !wahl.extra.has(k) || f(r))
      && (!q || r.title.toLowerCase().includes(q) || (r.zutaten || []).some((z) => z.toLowerCase().includes(q))));
    $$('button', dlgArten).forEach((b) => b.setAttribute('aria-pressed', b.dataset.art === wahl.art ? 'true' : 'false'));
    $$('button', dlgChips).forEach((b) => b.setAttribute('aria-pressed', (b.dataset.diet ? wahl.diaet === b.dataset.diet : wahl.extra.has(b.dataset.extra)) ? 'true' : 'false'));
    dlgCount.textContent = treffer.length === 1 ? T.countOne : fill(T.countOther, { count: treffer.length });
    dlgListe.innerHTML = treffer.length ? treffer.map((r) => `<button type="button" class="fc-pk" data-h="${esc(r.handle)}">
        <span class="fc-pk__img">${r.img ? `<img src="${r.img}" alt="" loading="lazy" width="400" height="300">` : ''}<span class="fc-tag fc-art fc-art--${({ 'frühstück': 'fruehstueck', 'hauptgericht': 'hauptgericht', 'snacks & desserts': 'snacks', 'dips & beilagen': 'dips' })[artVon(r)]}">${esc(artName(artVon(r)))}</span></span>
        <b>${esc(r.title)}</b>
        <small>${r.zeit ? `<span>${ICON_UHR} ${r.zeit} ${T.min}</span>` : ''}<span>${r.protein} ${T.gProtein}</span><span>${r.kcal} kcal</span></small>
      </button>`).join('') : `<p class="fc-pdlg__leer">${esc(T.noMatch)}</p>`;
    $$('.fc-pk', dlgListe).forEach((b) => b.addEventListener('click', () => { const r = nachHandle[b.dataset.h]; if (r && wahl.onPick) wahl.onPick(r); }));
  };
  dlgArten.innerHTML = [['', T.all || 'Alle']].concat(artenMitRezept.map((a) => [a, artName(a)])).map(([a, n]) => `<button type="button" data-art="${esc(a)}">${esc(n)}</button>`).join('');
  dlgChips.innerHTML = angeboten.map(([k]) => `<button type="button" class="fc-fchip" data-diet="${esc(k)}">${esc(diaetName(k))}</button>`).join('')
    + FILTER.map(([k, n]) => `<button type="button" class="fc-fchip" data-extra="${k}">${esc(n)}</button>`).join('');
  $$('button', dlgArten).forEach((b) => b.addEventListener('click', () => { wahl.art = b.dataset.art; zeigeListe(); }));
  $$('button', dlgChips).forEach((b) => b.addEventListener('click', () => {
    if (b.dataset.diet) wahl.diaet = wahl.diaet === b.dataset.diet ? '' : b.dataset.diet;
    else if (wahl.extra.has(b.dataset.extra)) wahl.extra.delete(b.dataset.extra); else wahl.extra.add(b.dataset.extra);
    zeigeListe();
  }));
  dlgSuche.addEventListener('input', zeigeListe);

  const waehle = (key) => {
    const [tk, sk] = key.split('-');
    const slot = SLOTS.find((s) => s[0] === sk);
    const tag = TAGE.find((t) => t[0] === tk);
    dlgTitel.textContent = fill(T.slotOnDay, { slot: slot[1], day: tag[1] });
    dlgSlot.hidden = true; dlgFilter.hidden = false; dlgCount.hidden = false; dlgListe.hidden = false;
    dlgSuche.value = '';
    // Vorauswahl: Art der Mahlzeit und gewählte Ernährung, alles lässt sich im Fenster ändern
    wahl = { art: slot[2], diaet: state.diaet, extra: new Set(), onPick: (r) => { setze(key, r.handle); speichern(); dlg.close(); renderWoche(); renderListe(); } };
    zeigeListe();
    oeffneDlg();
    dlgListe.scrollTop = 0;
  };
  /* Rezept von der Rezeptseite einplanen: Tag und Mahlzeit wählen */
  const einplanen = (r) => {
    dlgTitel.textContent = fill(T.planTitle, { title: r.title });
    dlgFilter.hidden = true; dlgCount.hidden = true; dlgListe.hidden = true;
    dlgSlot.hidden = false;
    const standard = SLOTS.find((s) => hatTag(r, s[2])) || SLOTS[1];
    dlgSlot.innerHTML = `<p class="fc-muted">${T.chooseSlot}</p>
      <div class="fc-planner__seg" data-slotwahl>${SLOTS.map((s) => `<button type="button" data-sk="${s[0]}" aria-pressed="${s === standard}">${s[1]}</button>`).join('')}</div>
      <div class="fc-planner__days">${TAGE.map((t) => `<button type="button" class="fc-fchip" data-tk="${t[0]}">${t[1]}</button>`).join('')}</div>`;
    let sk = standard[0];
    $$('[data-slotwahl] button', dlgSlot).forEach((b) => b.addEventListener('click', () => {
      sk = b.dataset.sk;
      $$('[data-slotwahl] button', dlgSlot).forEach((x) => x.setAttribute('aria-pressed', x === b ? 'true' : 'false'));
    }));
    $$('[data-tk]', dlgSlot).forEach((b) => b.addEventListener('click', () => {
      setze(b.dataset.tk + '-' + sk, r.handle); speichern(); dlg.close(); aktiv = b.dataset.tk; renderWoche(); renderListe();
      history.replaceState(null, '', location.pathname);
    }));
    oeffneDlg();
  };

  /* ---------- Woche vorschlagen ---------- */
  const pool = (art) => rezepte.filter((r) => hatTag(r, art) && passtDiaet(r));
  const spanne = (liste, f) => { const w = liste.map(f); const min = Math.min(...w); return { min, d: (Math.max(...w) - min) || 1 }; };
  const zielGewicht = (r, liste) => {
    if (!state.ziel || !liste.length) return 1;
    if (state.ziel === 'muskelaufbau') { const s = spanne(liste, (x) => x.protein || 0); return 0.4 + ((r.protein || 0) - s.min) / s.d + (hatTag(r, 'muskelaufbau') ? 0.8 : 0); }
    const s = spanne(liste, (x) => x.kcal || 0); return 0.4 + 1 - ((r.kcal || 0) - s.min) / s.d + (hatTag(r, 'abnehmen') ? 0.8 : 0);
  };
  const ziehe = (liste, gewicht) => {
    const w = liste.map((r) => Math.max(0, gewicht(r)));
    const summe = w.reduce((a, b) => a + b, 0);
    if (!liste.length || summe <= 0) return null;
    let x = Math.random() * summe;
    for (let i = 0; i < liste.length; i += 1) { x -= w[i]; if (x <= 0) return liste[i]; }
    return liste[liste.length - 1];
  };
  const vorschlagen = () => {
    const plan = {};
    const heute = (d) => new Set(SLOTS.map(([sk]) => plan[TAGE[d][0] + '-' + sk]).filter((v) => typeof v === 'string'));
    const handleAt = (k) => { const v = plan[k]; return typeof v === 'string' ? v : v && typeof plan[v.von] === 'string' ? plan[v.von] : null; };

    /* Hauptmahlzeiten: abends kochen, mittags Rest oder schnelles Rezept */
    const H = pool('hauptgericht');
    const kochAnzahl = new Map();
    const zuletzt = new Map(); // Handle → letzter Tag, an dem gekocht wurde
    const frei = (r, d) => (kochAnzahl.get(r.handle) || 0) < 2 && !(zuletzt.has(r.handle) && d - zuletzt.get(r.handle) < 3) && !heute(d).has(r.handle);
    const kochen = (key, r, d) => { plan[key] = r.handle; kochAnzahl.set(r.handle, (kochAnzahl.get(r.handle) || 0) + 1); zuletzt.set(r.handle, d); };
    TAGE.forEach(([tk], d) => {
      const werktag = d < 5;
      const gestern = d > 0 ? TAGE[d - 1][0] + '-ab' : null;
      const gesternR = gestern && nachHandle[plan[gestern]];
      if (state.reste && gesternR && hatTag(gesternR, 'meal prep')) plan[tk + '-mi'] = { von: gestern };
      else {
        const cand = H.filter((r) => frei(r, d));
        const r = ziehe(cand.length ? cand : H.filter((x) => !heute(d).has(x.handle)), (x) => zielGewicht(x, H) * (werktag ? ((x.zeit || 99) <= 20 ? 3 : (x.zeit || 99) <= 30 ? 0.4 : 0.15) : 1));
        if (r) kochen(tk + '-mi', r, d);
      }
      // Abend: vor einem Folgetag lieber ein Gericht zum Vorkochen, damit es mittags Reste gibt
      const reste = state.reste && d < 6;
      const mittagH = handleAt(tk + '-mi');
      const cand = H.filter((r) => frei(r, d) && r.handle !== mittagH);
      const r = ziehe(cand.length ? cand : H.filter((x) => x.handle !== mittagH && !heute(d).has(x.handle)), (x) => zielGewicht(x, H) * (reste && hatTag(x, 'meal prep') ? 4 : 1) * (werktag && (x.zeit || 0) > 45 ? 0.4 : 1));
      if (r) kochen(tk + '-ab', r, d);
    });

    /* Frühstück: unter der Woche schnell oder für 2 Tage vorbereitet, am Wochenende gern aufwendiger */
    const F = pool('frühstück');
    for (let d = 0; d < 7;) {
      const tk = TAGE[d][0]; const werktag = d < 5;
      const vorher = d > 0 ? handleAt(TAGE[d - 1][0] + '-fr') : null;
      const cand = F.filter((r) => r.handle !== vorher && !heute(d).has(r.handle) && (kochAnzahl.get(r.handle) || 0) < 2);
      const r = ziehe(cand.length ? cand : F, (x) => zielGewicht(x, F) * (werktag ? ((x.zeit || 99) <= 15 ? 2.5 : (x.zeit || 99) <= 20 ? 1 : 0.05) * (hatTag(x, 'meal prep') ? 1.5 : 1) : ((x.zeit || 0) >= 20 ? 2.5 : 1)));
      if (!r) { d += 1; continue; }
      plan[tk + '-fr'] = r.handle;
      kochAnzahl.set(r.handle, (kochAnzahl.get(r.handle) || 0) + 1);
      let laenge = 1;
      if (werktag && hatTag(r, 'meal prep')) laenge = Math.min(2, 5 - d);
      for (let j = 1; j < laenge; j += 1) plan[TAGE[d + j][0] + '-fr'] = { von: tk + '-fr' };
      d += laenge;
    }

    /* Snacks: auf Vorrat, so viele Tage wie die Portionen für alle reichen (Gebäck höchstens 4, Dips höchstens 3 Tage) */
    const S = rezepte.filter((r) => passtDiaet(r) && (hatTag(r, 'snacks & desserts') || (hatTag(r, 'dips & beilagen') && (r.kcal || 999) <= 200)));
    for (let d = 0; d < 7;) {
      const tk = TAGE[d][0];
      const vorher = d > 0 ? handleAt(TAGE[d - 1][0] + '-sn') : null;
      const cand = S.filter((r) => r.handle !== vorher);
      const r = ziehe(cand.length ? cand : S, (x) => zielGewicht(x, S) * (hatTag(x, 'dips & beilagen') ? 0.6 : 1));
      if (!r) { d += 1; continue; }
      plan[tk + '-sn'] = r.handle;
      const max = hatTag(r, 'dips & beilagen') ? 3 : 4;
      const laenge = Math.max(1, Math.min(max, Math.floor((r.portionen || 1) / Math.max(1, state.personen || 1)), 7 - d));
      for (let j = 1; j < laenge; j += 1) plan[TAGE[d + j][0] + '-sn'] = { von: tk + '-sn' };
      d += laenge;
    }

    state.plan = plan;
    speichern(); renderWoche(); renderListe();
    const leer = ALLE - Object.keys(plan).length;
    zeigeHinweis(leer ? (state.diaet ? fill(T.dietGaps, { diet: diaetName(state.diaet) }) : T.gaps) + ' ' + fill(T.gapsCount, { count: leer, total: ALLE }) : '');
  };

  /* ---------- Einkaufsliste: jede Mahlzeit zählt mit der Personenzahl, Reste und Vorrat inklusive ---------- */
  const shop = $('[data-fc-planner-shop]', planer);
  const shopListe = $('[data-fc-planner-shoplist]', planer);
  const EINHEITEN = ['g', 'kg', 'ml', 'dl', 'l', 'EL', 'TL', 'Prise', 'Prisen', 'Scheibe', 'Scheiben', 'Stange', 'Stangen',
    'tbsp', 'tsp', 'pinch', 'slice', 'slices', 'stalk', 'stalks', 'c.s.', 'c.c.', 'pincée', 'pincées', 'tranche', 'tranches', 'branche', 'branches'];
  const zerlege = (zeile) => {
    const m = zeile.match(RE_MENGE);
    if (!m) return { menge: null, einheit: '', name: zeile };
    let rest = zeile.slice(m[0].length);
    let einheit = '';
    const e = rest.match(/^(\S+)\s+/);
    if (e && EINHEITEN.includes(e[1])) { einheit = e[1]; rest = rest.slice(e[0].length); }
    const name = rest.replace(/\s*\([^)]*\)/g, '').split(',')[0].trim();
    return { menge: toNum(m[1]), einheit, name };
  };
  const renderListe = () => {
    if (shop.hidden) return;
    const summe = new Map();
    const sonst = new Set();
    Object.keys(state.plan).forEach((key) => {
      const e = eintrag(key);
      if (!e) return;
      const r = e.r;
      const f = (state.personen || 1) / (r.portionen || 1);
      (r.zutaten || []).forEach((z) => {
        const t = zerlege(z);
        if (t.menge === null) { sonst.add(z); return; }
        const k = t.name.toLowerCase() + '|' + t.einheit;
        const alt = summe.get(k) || { name: t.name, einheit: t.einheit, menge: 0 };
        alt.menge += t.menge * f;
        summe.set(k, alt);
      });
    });
    if (!summe.size && !sonst.size) { shopListe.innerHTML = `<p class="fc-muted">${T.listEmpty}</p>`; return; }
    const zeilen = [...summe.values()].sort((a, b) => a.name.localeCompare(b.name, T.lang))
      .map((z) => `<li><label><input type="checkbox"><span><b>${fmt(z.menge)}${z.einheit ? ' ' + z.einheit : ''}</b> ${esc(z.name)}</span></label></li>`);
    const extra = [...sonst].map((z) => `<li><label><input type="checkbox"><span>${esc(z)}</span></label></li>`);
    shopListe.innerHTML = `<ul class="fc-shoplist">${zeilen.join('')}</ul>${extra.length ? `<p class="fc-planner__lbl">${T.also}</p><ul class="fc-shoplist">${extra.join('')}</ul>` : ''}<p class="fc-muted fc-planner__hint">${fill(T.hint, { count: state.personen, persons: state.personen === 1 ? T.person : T.people })}</p>`;
  };

  /* ---------- Bedienelemente ---------- */
  const zielBtns = $$('[data-fc-planner-goal] button', planer);
  const zielZeigen = () => zielBtns.forEach((b) => b.setAttribute('aria-pressed', b.dataset.goal === state.ziel ? 'true' : 'false'));
  zielBtns.forEach((b) => b.addEventListener('click', () => { state.ziel = b.dataset.goal; speichern(); zielZeigen(); }));
  /* Ernährung: nur die Formen, für die es Rezepte gibt, mit Anzahl passender Rezepte */
  const diaetWrap = $('[data-fc-planner-diet-wrap]', planer);
  const diaetSeg = $('[data-fc-planner-diet]', planer);
  if (angeboten.length) {
    diaetSeg.innerHTML = `<button type="button" data-diet="">${T.dietAll}</button>` + angeboten.map(([k]) => `<button type="button" data-diet="${esc(k)}">${esc(diaetName(k))} <small>${rezepte.filter((r) => passtZu(r, k)).length}</small></button>`).join('');
    diaetWrap.hidden = false;
  }
  const diaetBtns = $$('button', diaetSeg);
  const diaetZeigen = () => diaetBtns.forEach((b) => b.setAttribute('aria-pressed', b.dataset.diet === state.diaet ? 'true' : 'false'));
  diaetBtns.forEach((b) => b.addEventListener('click', () => {
    state.diaet = b.dataset.diet; speichern(); diaetZeigen(); renderWoche();
    /* Bestehender Plan bleibt; passt etwas nicht zur neuen Form, wird es blass gezeigt und neu vorschlagen angeboten */
    const falsch = Object.keys(state.plan).filter((k) => { const e = eintrag(k); return e && !e.von && !passtDiaet(e.r); }).length;
    zeigeHinweis(falsch ? fill(T.dietChanged, { count: falsch, diet: diaetName(state.diaet) }) : '', true);
  }));
  const pers = $('[data-fc-planner-persons]', planer);
  const persZeigen = () => { $('[data-value]', pers).textContent = state.personen; };
  $('[data-minus]', pers).addEventListener('click', () => { if (state.personen > 1) { state.personen -= 1; speichern(); persZeigen(); renderListe(); } });
  $('[data-plus]', pers).addEventListener('click', () => { if (state.personen < 8) { state.personen += 1; speichern(); persZeigen(); renderListe(); } });
  const resteBox = $('[data-fc-planner-reste]', planer);
  if (resteBox) {
    resteBox.checked = state.reste !== false;
    resteBox.addEventListener('change', () => { state.reste = resteBox.checked; speichern(); });
  }
  $('[data-fc-planner-suggest]', planer).addEventListener('click', vorschlagen);
  $('[data-fc-planner-clear]', planer).addEventListener('click', () => { state.plan = {}; speichern(); zeigeHinweis(''); renderWoche(); renderListe(); });
  $('[data-fc-planner-list]', planer).addEventListener('click', () => {
    shop.hidden = false; renderListe(); shop.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  zielZeigen(); diaetZeigen(); persZeigen(); renderWoche();
  const neu = new URLSearchParams(location.search).get('rezept');
  if (neu && nachHandle[neu]) einplanen(nachHandle[neu]);
})();


/* Rezeptseite: Bilder anklicken öffnet die gemeinsame Galerie (window.fcLightbox in foodcore.js), dunkel, mit Zoom und Schritt-Text.
   Zeigt sofort das geladene Bild und lädt die scharfe Fassung nach (Wilhelm 30.10.2026: «Bilder laden lange beim Weiterschalten») */
(() => {
  const rezept = document.querySelector('.fc-recipe');
  if (!rezept) return;
  const T = window.fcRecipesT || {};
  const quellen = [...rezept.querySelectorAll('.fc-recipe__hero img, .fc-step__img img')];
  if (!quellen.length) return;
  const bilder = quellen.map((img) => {
    const step = img.closest('.fc-step');
    let cap = '';
    if (step) {
      const n = (step.querySelector('.fc-step__num') || {}).textContent || '';
      const p = (step.querySelector('.fc-step__txt p') || {}).textContent || '';
      cap = (T.lbStep || 'Schritt [n]').replace('[n]', n.trim()) + ' · ' + p.trim();
    }
    return { img, cap };
  });
  const oeffne = (i) => { if (window.fcLightbox) window.fcLightbox.open(bilder, i, { dunkel: true, titel: T.lbGallery || '' }); };
  bilder.forEach((b, i) => {
    const box = b.img.parentElement;
    box.classList.add('fc-zoomable'); box.setAttribute('role', 'button'); box.tabIndex = 0;
    box.setAttribute('aria-label', (T.lbOpen || 'Bild vergrössern') + (b.img.alt ? ': ' + b.img.alt : ''));
    box.addEventListener('click', () => oeffne(i));
    box.addEventListener('keydown', (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); oeffne(i); } });
  });
})();
